export const setCode = (state = null, action) => {
  switch (action.type) {
    case 'SET_CODE':
      return action.code;
    default:
      return state;
  }
}
